import CrudActionSetBase from './CrudActionSetBase'

export class SubstationActionSet extends CrudActionSetBase('substation'){
  static initialState = {
    substation: { tags: {}, loads: {} }
  }
}
export default new SubstationActionSet()